import createColor from 'color';

export const rgba = (color, alpha) => {
  return createColor(color).rgb().alpha(alpha).string();
};
